import { forwardRef, useEffect, useImperativeHandle } from 'react';
import { Controller, FormProvider, useForm, useWatch } from 'react-hook-form';
import { SearchOutlined } from '@ant-design/icons';
import { Form, Select, Tooltip } from 'antd';
import cx from 'classnames';
import get from 'lodash/get';
import { observer } from 'mobx-react';
import { useStores } from '@gtintel/platform-stores';
import { TagRequestMode } from '@gtintel/platform-types';
import TagOption from './components/TagOption';
import { TagFormValues } from './constants';
import styles from './tagsForm.module.scss';
import { buildTagGroupsTree, extractSelectedTagIds, extractSelectedTags } from './utils';
const TagsForm = (props, childRef) => {
  const {
    defaultValue
  } = props;
  const {
    tagGroupStore
  } = useStores();
  const {
    tagGroups
  } = tagGroupStore;
  const methods = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {}
  });
  const {
    control,
    getValues,
    reset
  } = methods;
  const formValues = useWatch({
    name: TagFormValues.TAG_GROUPS,
    control
  });
  useEffect(() => {
    tagGroupStore?.fetchTagGroups(TagRequestMode.RELATION);
  }, []);
  useEffect(() => {
    const tagGroupTree = buildTagGroupsTree(tagGroups, defaultValue);
    const formValues = [];
    tagGroupTree?.forEach(tagGroup => {
      formValues[tagGroup?.id] = Array.isArray(tagGroup?.tags) ? tagGroup?.tags?.map(tag => tag.id) : [];
    });
    reset({
      tagGroups: formValues
    });
  }, [tagGroups]);
  function getTagIds() {
    const formValues = getValues();
    const tagIds = extractSelectedTagIds(formValues);
    return tagIds;
  }
  useImperativeHandle(childRef, () => ({
    getTagIds
  }));
  return <FormProvider {...methods}>
      {Array.isArray(tagGroups) && tagGroups?.map((tagGroup, index) => {
      const selectedTagIds = get(formValues, `${tagGroup?.id}`, []);
      const selectedTags = extractSelectedTags(selectedTagIds, tagGroup?.tags);
      return <Form.Item key={index} name={tagGroup?.id} label={tagGroup?.name} className={cx('form-tags', styles.inputSection)}>
              <Controller name={`${TagFormValues.TAG_GROUPS}.${tagGroup.id}`} control={control} defaultValue={[]} render={({
          field
        }) => {
          return <Select {...field} mode="multiple" placeholder={`Search ${tagGroup?.name} tags`} optionFilterProp="label" className={cx('selectNew', styles.selection)} showSearch showArrow suffixIcon={<Tooltip title="Copy">
                          <SearchOutlined type="copy" />
                        </Tooltip>}>
                      {Array.isArray(tagGroup?.tags) && tagGroup?.tags?.map((tag, tagIndex) => {
              return <Select.Option key={tagIndex} value={tag.id} label={tag.name} color={tag.tag_group_code ?? tag.tag_group}>
                              <TagOption tag={tag} />
                            </Select.Option>;
            })}
                    </Select>;
        }} />
              {/*TODO: using it later
               !selectedTags?.length && (
                <div className={styles.errorMessage}>
                  Please input your tags!
                </div>
               )*/}
              {Array.isArray(selectedTags) && selectedTags?.length > 0 && <div className="wrap-tags tags-edit">
                  {selectedTags?.map((tag, index) => <TagOption key={index} tag={tag} />)}
                </div>}
            </Form.Item>;
    })}
    </FormProvider>;
};
export default observer(forwardRef(TagsForm));